<template>
<div class="chapter">
<div class="inner_page">
<p class="fmtitle"><a id="page_xiii">ACKNOWLEDGMENTS</a></p><a id="page_xiii">
<p class="noindent">Thank you to readers who offered valuable feedback and encouragement along the way: Rachelle Ackerman, Steve Adams, Jan Brown, Lonnie Fairchild, Elizabeth Garfield, Allen Lang, Diana Maher, Danny Miller, Sorrel North, Douglas Skopp.</p>
<p class="indent">Thank you to writing group colleagues for steadfast support: Elizabeth Garfield and Douglas Skopp (again), Susan Carr, Imelda Daranciang, Susie Irwin, Lorna Lee, Cynthia Newgarden, Laura Palkovic, Ann Tracy, Vera Vivante.</p>
<p class="indent">Thank you to Tom Moran and the Institute for Ethics in Public Life at SUNY Plattsburgh for a room of my own and a place at the table, and to Mike Morgan for guidance on voicing techniques.</p>
<p class="indent">Thank you to all whose stories, opinions, and insights have guided and inspired me.</p>
<p class="indent">Thank you to Sarah Jacobi and Break Away Books for believing in this project.</p>
<p class="indent">Thank you to Doug Selwyn for more reasons than I have room to list.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 10_Acknowledgement.vue?2ebbe0b2